module.exports = __webpack_public_path__ + "assets/clear_icon.31eb1427.svg";